import { isBefore, isValid, parse, startOfDay } from "date-fns";
import {
  OPEN_FOR_SUBMISSION_STATUSES,
  TODO_DUE_DATE_FORMAT,
  TODO_LOCK_REASONS,
} from "@/components/forms/TodoSubmissionRules/constants";
import type { TodoLockReason } from "@/components/forms/TodoSubmissionRules/types";
import type { TodoSubmission } from "@/components/MyStudentDetail/FilterableTodosSection/types";

const isPastDueDate = (dueDate: string | undefined, today: Date): boolean => {
  const parsed = parse(dueDate ?? "", TODO_DUE_DATE_FORMAT, today);
  return isValid(parsed) && isBefore(parsed, startOfDay(today));
};

export const getTodoLockReason = (
  todo: TodoSubmission | undefined,
  today: Date = new Date(),
): TodoLockReason | undefined => {
  let reason: TodoLockReason | undefined;
  if (!todo || OPEN_FOR_SUBMISSION_STATUSES.includes(todo.status)) {
    reason = undefined;
  } else if (!todo.allow_edit_after_submission) {
    reason = TODO_LOCK_REASONS.editNotAllowed;
  } else if (todo.lock_after_due_date && isPastDueDate(todo.due_date, today)) {
    reason = TODO_LOCK_REASONS.dueDatePassed;
  }
  return reason;
};
